import Vue from 'vue'

import {
    Button,
    Input,
    Form,
    FormItem,
    Spin,
    Icon,
    Message,
    Modal,
    BackTop,
    Tag,
    Dropdown,
    DropdownItem,
    DropdownMenu,
    Tabs,
    TabPane,
    Timeline,
    TimelineItem,
    Checkbox,
    CheckboxGroup,
    Divider,
    Poptip,
    Page, RadioGroup, Radio,
    Table, Select, Option, InputNumber, Upload, Progress
} from 'view-design'

Vue.component('Poptip', Poptip)
Vue.component('Dropdown', Dropdown)
Vue.component('CheckboxGroup', CheckboxGroup)
Vue.component('RadioGroup', RadioGroup)
Vue.component('Radio', Radio)
Vue.component('BackTop', BackTop)
Vue.component('DropdownItem', DropdownItem)
Vue.component('DropdownMenu', DropdownMenu)
Vue.component('Progress', Progress)
Vue.component('Button', Button)
Vue.component('Input', Input)
Vue.component('Form', Form)
Vue.component('FormItem', FormItem)
Vue.component('Icon', Icon)
Vue.component('Spin', Spin)
Vue.component('Tag', Tag)
Vue.component('Tabs', Tabs)
Vue.component('TabPane', TabPane)
Vue.component('Modal', Modal)
Vue.component('Timeline', Timeline)
Vue.component('TimelineItem', TimelineItem)
Vue.component('Checkbox', Checkbox)
Vue.component('Divider', Divider)
Vue.component('Page', Page)
Vue.component('Table', Table)
Vue.component('Select', Select)
Vue.component('Option', Option)
Vue.component('InputNumber', InputNumber)
Vue.component('Upload', Upload)

Message.config({
    duration: 3,
})
Vue.prototype.$Message = Message
Vue.prototype.$Modal = Modal